"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_service_1 = require("../../shared/service/http.service");
var empty_1 = require("../../shared/error/empty");
var find_http_error_1 = require("../../shared/error/find-http-error");
var Subject_1 = require("rxjs/Subject");
var AppraisalTestService = /** @class */ (function () {
    function AppraisalTestService(_httpService) {
        this._httpService = _httpService;
        this.CREATE_AS_MAP = AppraisalTestService.APPRAISAL_TEST_END_POINT + "/createAsMap";
        this.FIND_AS_MAP = AppraisalTestService.APPRAISAL_TEST_END_POINT + "/findAsMap";
        this.findSubject = new Subject_1.Subject();
        this.find$ = this.findSubject.asObservable();
        this.errorSubject = new Subject_1.Subject();
        this.error$ = this.errorSubject.asObservable();
    }
    AppraisalTestService.prototype.createAsMap = function (equipmentType) {
        this.findAppraisalTestItems(this._httpService.post(this.CREATE_AS_MAP, equipmentType, empty_1.Empty, find_http_error_1.FindHttpError));
    };
    AppraisalTestService.prototype.findAsMap = function (appraisalId) {
        this.findAppraisalTestItems(this._httpService.get(this.FIND_AS_MAP + "/" + appraisalId, empty_1.Empty, find_http_error_1.FindHttpError));
    };
    AppraisalTestService.prototype.findAppraisalTestItems = function (observable) {
        var _this = this;
        observable
            .subscribe(function (items) { return _this.findSubject.next(items); }, function (error) { return _this.errorSubject.next(error); });
    };
    AppraisalTestService.ctorParameters = function () { return [{ type: http_service_1.HttpService }]; };
    AppraisalTestService.APPRAISAL_TEST_END_POINT = '/appraisalTest';
    return AppraisalTestService;
}());
exports.AppraisalTestService = AppraisalTestService;
//# sourceMappingURL=appraisal-test.service.js.map


// WEBPACK FOOTER //
// appraisal-test.service.js